// extracted by mini-css-extract-plugin
export default {"container":"rJ-z","modal":"sJ-z","dimensions":"tJ-z","brandName":"uJ-z","productName":"vJ-z","labelValue":"wJ-z","recipientEmail":"xJ-z","recommendedFit":"yJ-z","hiddenField":"zJ-z"};